import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-public-registration',
  templateUrl: './public-registration.component.html',
  styleUrls: ['./public-registration.component.scss']
})
export class PublicRegistrationComponent implements OnInit {

  formProgressReport: FormGroup;
  mycatchaResponse: string = null;
  helpOptions: any[] = [];

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.formProgressReport = this.fb.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      company: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      referral: [''],
      how_we_can_help: ['', Validators.required]
    });
  }

  resolved(captchaResponse: string): void {
    this.mycatchaResponse = captchaResponse;
  }

  onError(errorDetails: string): void {
    console.warn('reCAPTCHA error', errorDetails);
  }

  onSubmit(): void {
    if (this.formProgressReport.invalid || !this.mycatchaResponse) {
      return;
    }

    const data = {
      ...this.formProgressReport.value,
      apikey: 'HEREAPIKEY',
      tag: 'Schedule_a_Demo'
    };

    console.log('Sending data:', data);

    // Aquí puedes agregar el llamado real al backend con fetch o HttpClient
  }
}
